<template>
  <div class="custom-cursor-container" :class="{ 'cursor-hidden': isOverIframe || isOutsideWindow }" :style="containerStyle">
    <div class="cursor-wrapper cursor-type-emoji">
      <div
        v-for="state in cursorStates"
        :key="`state-${state.name}`"
        class="cursor-state"
        :class="[`cursor-state-${state.name}`, { active: currentState === state.name }]"
      >
        <InlineSvg v-if="state.svg?.layer2" :src="state.svg.layer2" class="cursor-svg-layer2" />
        <InlineSvg v-if="state.svg?.layer1" :src="state.svg.layer1" class="cursor-svg-layer1" />
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'CursorEmoji' };
</script>

<script setup>
import { computed } from 'vue';
import InlineSvg from 'vue-inline-svg';
import { useCursorState } from './useCursorState.js';
import { getCursorSvg as getSharedCursorSvg } from '../../../utilities/useCursorSvg.js';

const { currentState, containerStyle, isOverIframe, isOutsideWindow } = useCursorState();

function getCursorSvg(state) {
  return getSharedCursorSvg('EMOJI', state);
}

const cursorStates = computed(() => [
  { name: 'default', svg: getCursorSvg('default') },
  { name: 'hover',   svg: getCursorSvg('hover') },
  { name: 'project', svg: getCursorSvg('project_hover') },
].filter(s => s.svg));
</script>

<style scoped lang="scss">
@import './cursor-shared';

// No unique styles — all rules inherited from the shared partial.
</style>
